import {
  alias,
  customType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

const String = stringType();

const PayPalInitResponse = shapeType({
  cancelUrl: String,
  cartId: String,
  paypalUrl: String,
  returnUrl: String,
  token: String
});

const Experience = {
  component: String,
  type: String,
};

const ExpTypeFilter = {
  type: String
};

const RequestContext = shapeType({
  cartId: String,
  experience: Experience,
  expTypeFilter: ExpTypeFilter,
  tmxProfileId: String
});
const requestContext = customType('RequestContext').shape(RequestContext);

export const initPaypal = {
  initPaypal: alias('initPaypal').params({ requestContext }).shape(PayPalInitResponse)
};